import styled from 'styled-components'

// Components
import { Link } from '@sketch/components'

export const Wrapper = styled.div`
  width: 400px;
`

export const StyledLink = styled(Link)`
  display: block;
  width: 100%;
  margin-top: 24px;
  text-align: center;
`
